export function replaceSeparators(string) {
  if (!string) return "";
  string = string.replaceAll(",", "#");
  string = string.replaceAll(".", "");
  string = string.replaceAll("#", ".");
  return string;
}
